import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import config from '../../../config/app';
import getTestModeParams from '../../utils/getTestModeParams';



const AccountSwitchMode = ({
  users,
}) => {
  const testModeParams = getTestModeParams();
  const [ hoveredUserId, setHoveredUserId ] = useState(null);
  const selectedUserId = testModeParams?.developer_id;
  const specialUserIds = [ 695, 709, 607 ];

  const handleApplyTestMode = (executor) => {
    const requestParams = { is_developer: config.test_mode_token, developer_id: executor.value, username: executor.label };

    localStorage.setItem('test_mode_params', JSON.stringify(requestParams));
    localStorage.removeItem('selected_role');
    window.location.reload();
  };

  const getUsersList = users ? users.filter((user) => specialUserIds.includes(user.id))
    .sort((first, second) => specialUserIds.indexOf(first.id) - specialUserIds.indexOf(second.id)) : [];

  const switchButton = (user) => {
    const userStyles = {
      695: { btnText: 'CM', color: '#91CAFF' },
      709: { btnText: 'LE', color: '#5CDBD3' },
      607: { btnText: 'C', color: '#FFD666' },
    };

    const { btnText, color } = userStyles[user.id] || {};
    const isHovered = hoveredUserId === user.id;
    const isSelected = selectedUserId === user.id;

    return (
      <Button
        key={user.id}
        type="secondary"
        className="account-switch-button"
        style={{ borderColor: color, backgroundColor: (isHovered || isSelected) ? color : '#ffffff' }}
        onMouseEnter={() => setHoveredUserId(user.id)}
        onMouseLeave={() => setHoveredUserId(null)}
        onClick={() => {
          if (user.id !== selectedUserId) {
            handleApplyTestMode({
              value: user.id,
              label: user.username,
            });
          }
        }}
      >
        {btnText}
      </Button>
    );
  };

  return (
    <>
      <div className="text-center account-switch">
        {getUsersList.map((user) => {
          return switchButton(user);
        })}
      </div>
    </>
  );
};

AccountSwitchMode.propTypes = {
  users: PropTypes.array,
};

export default AccountSwitchMode;
